import React, { useMemo } from 'react';

import logoTB from 'assets/img/brand/logo.png';
import logoMiniTB from 'assets/img/brand/logo_mini.png';
import faviconTB from 'assets/img/brand/logo_mini.png';

import logoBlast from 'assets/img/brand/blast/logo.png';
import logoMiniBlast from 'assets/img/brand/blast/logo_mini.png';
import faviconBlast from 'assets/img/brand/blast/favicon.png';

import logoIristel from 'assets/img/brand/iristel/logo.png';
import logoMiniIristel from 'assets/img/brand/iristel/logo_mini.png';
import faviconIristel from 'assets/img/brand/iristel/favicon.png';
import { ProdLinksEnum } from 'consts/data';

const WebConfigsContext = React.createContext({
  logo: '',
  logoMini: '',
  favicon: '',
  title: '',
  isTextback: false,
});

export const useWebConfigs = () => React.useContext(WebConfigsContext);

const WebConfigsProvider = ({ children }) => {
  const configs = useMemo(() => {
    //! Default: Textback
    let logo = logoTB;
    let logoMini = logoMiniTB;
    let favicon = faviconTB;
    let title = 'Textback.ai';
    let isTextback = true;

    //! Blast connect
    if (window.location.hostname.includes(ProdLinksEnum.blastConnect)) {
      title = 'Blastconnect.ai';
      logo = logoBlast;
      logoMini = logoMiniBlast;
      favicon = faviconBlast;
      isTextback = false;
    }

    //! Iristel
    if (window.location.hostname.includes(ProdLinksEnum.iristel)) {
      title = 'Iristel AI';
      logo = logoIristel;
      logoMini = logoMiniIristel;
      favicon = faviconIristel;
      isTextback = false;
    }

    return {
      logo,
      logoMini,
      favicon,
      title,
      isTextback,
    };
  }, []);

  const value = useMemo(() => {
    return {
      ...configs,
    };
  }, [configs]);

  return <WebConfigsContext.Provider value={value}>{children}</WebConfigsContext.Provider>;
};

export default WebConfigsProvider;
